"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent, meetingId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.meetingId = meetingId;
    }
    path(withParameter = true) {
        if (withParameter && this.meetingId !== null) {
            return `${this.parent.path()}/meetings/${this.meetingId}`;
        }
        return `${this.parent.path()}/meetings`;
    }
    /**
     * Returns the list of user meetings.
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/history/meetings
     * Rate Limit Group: Light
     * App Permission: Video
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user meeting by ID.
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/history/meetings/{meetingId}
     * Rate Limit Group: Light
     * App Permission: Video
     */
    async get(restRequestConfig) {
        if (this.meetingId === null) {
            throw new Error('meetingId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map